import React from 'react'
import { Link } from 'react-router-dom'

function Faqs() {
  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">Faqs</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="active fw-500"> Faqs </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Subheader --> 
    <!-- Start faqs --> */}
    <section className="section-padding bg-light-white faqs">
      <div className="container">
        <div className="row">
          <h6 className="d-none">1</h6>
          <div className="col-lg-8">
            <div id="accordion" className="custom-accordion">
              <div className="card">
                <div className="card-header" id="headingOne">
                  <button className="collapsebtn" data-toggle="collapse" data-target="#collapseOne"> Rules and Policies </button>
                </div>
                <div id="collapseOne" className="collapse show" data-parent="#accordion">
                  <div className="card-body">
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme no-margin"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="headingTwo">
                  <button className="collapsebtn collapsed" data-toggle="collapse" data-target="#collapseTwo"> Bicycle Changes </button>
                </div>
                <div id="collapseTwo" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme no-margin"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="headingThree">
                  <button className="collapsebtn collapsed" data-toggle="collapse" data-target="#collapseThree"> Refunds </button>
                </div>
                <div id="collapseThree" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme no-margin"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="headingFour">
                  <button className="collapsebtn collapsed" data-toggle="collapse" data-target="#collapseFour"> Bicycle Penalties </button>
                </div>
                <div id="collapseFour" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme no-margin"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="headingFive">
                  <button className="collapsebtn collapsed" data-toggle="collapse" data-target="#collapseFive"> Bicycle Cancellation </button>
                </div>
                <div id="collapseFive" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme no-margin"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="headingSix">
                  <button className="collapsebtn collapsed" data-toggle="collapse" data-target="#collapseSix"> Bicycle Terms of Use </button>
                </div>
                <div id="collapseSix" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                    <p className="text-theme no-margin"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <aside className="col-lg-4">
            <div className="sidebar_wrap mb-md-80">
              <div className="sidebar">
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Search</h5>
                  </div>
                  <form>
                    <div className="input-group group-form">
                      <input type="search" name="#" className="form-control form-control-custom" placeholder="Search"/>
                      <span className="input-group-append"> <i className="fas fa-search"></i> </span> </div>
                  </form>
                </div>
                <div className="sidebar_widgets">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">FAQs Topic</h5>
                  </div>
                  <form className="checkbox-group">
                    <div className="form-group">
                      <label className="custom-checkbox">
                        <input type="checkbox" name="#" />
                        <span className="checkmark"></span> All </label>
                    </div>
                    <div className="form-group">
                      <label className="custom-checkbox">
                        <input type="checkbox" name="#"/>
                        <span className="checkmark"></span> Features </label>
                    </div>
                    <div className="form-group">
                      <label className="custom-checkbox">
                        <input type="checkbox" name="#"/>
                        <span className="checkmark"></span> Sliders </label>
                    </div>
                    <div className="form-group">
                      <label className="custom-checkbox">
                        <input type="checkbox" name="#"/>
                        <span className="checkmark"></span> Manage Listing </label>
                    </div>
                    <div className="form-group">
                      <label className="custom-checkbox">
                        <input type="checkbox" name="#"/>
                        <span className="checkmark"></span> Address & Map </label>
                    </div>
                    <div className="form-group">
                      <label className="custom-checkbox">
                        <input type="checkbox" name="#"/>
                        <span className="checkmark"></span> Reservation Request </label>
                    </div>
                    <div className="form-group">
                      <label className="custom-checkbox">
                        <input type="checkbox" name="#"/>
                        <span className="checkmark"></span> Your Reservation </label>
                    </div>
                    <div className="form-group">
                      <label className="custom-checkbox">
                        <input type="checkbox" name="#"/>
                        <span className="checkmark"></span> Other Questions </label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
    </div>
  )
}

export default Faqs